{
  "PATH_TO_POINTER": {
    "eventId": 107,
    "adapter": "document",
    "params": {
      "methodName": "methodName",
      "path": "path"
    },
    "src": 40,
    "reportType": "event",
    "sampleRatio": 0
  }
}
